import { render, staticRenderFns } from "./RoleEditView.vue?vue&type=template&id=77c0d03a&scoped=true"
import script from "./RoleEditView.vue?vue&type=script&lang=js"
export * from "./RoleEditView.vue?vue&type=script&lang=js"
import style0 from "./RoleEditView.vue?vue&type=style&index=0&id=77c0d03a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c0d03a",
  null
  
)

export default component.exports